import gql from 'graphql-tag';

export default gql`
  query($projectId: ID!, $bookshopId: ID!) {
    project(projectId: $projectId) {
      id
      name
      goal
      state
      requirements {
        keywords
        budget
      }
      library {
        id
        name
      }
      createdAt
      library {
        id
      }
    }

    suggestionsListFromBookshopAndProject(
      projectId: $projectId
      bookshopId: $bookshopId
    ) {
      id
      name
    }
  }
`;
